/** Merge committed composer text with interim/final speech recognition output. */

export function composeSpeechValue(committed: string, interim: string): string {
    const interimTrimmed = interim.trim();
    if (!interimTrimmed) return committed;

    const base = committed.trimEnd();
    if (!base) return interimTrimmed;
    return `${base} ${interimTrimmed}`;
}

export function appendFinalTranscript(committed: string, finalText: string): string {
    const finalTrimmed = finalText.trim();
    if (!finalTrimmed) return committed;

    const base = committed.trimEnd();
    if (!base) return finalTrimmed;
    return `${base} ${finalTrimmed}`;
}
